import React, { useEffect, useState } from "react";
import FormList from "../components/FormList";
import CreateFormPage from "../pages/CreateForm";
import FeedbackModal from "../components/FeedbackModal";
import { getForms } from "../api";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";

const FormManagement = () => {
    const [forms, setForms] = useState([]);
    const [selectedForm, setSelectedForm] = useState(null);
    const [createForm, setCreateForm] = useState(null);
    const [refreshList, setRefreshList] = useState(false);
    const [feedbackMessage, setFeedbackMessage] = useState(null);
    const [loading, setLoading] = useState(true); // 🔹 New loading state
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const universityId = localStorage.getItem("universityId");
    const token = localStorage.getItem("token"); // Retrieve the token from local storage

    useEffect(() => {
        setLoading(true); // Start loading before fetching forms
        getForms()
            .then((response) => {
                console.log("Forms fetched:", response);
                setForms(response);
            })
            .catch((error) => {
                console.error("Error fetching forms:", error);
                setFeedbackMessage("Failed to fetch forms. Please try again.");
            })
            .finally(() => {
                setLoading(false); // Stop loading after fetching
            });
    }, [refreshList]);

    const handleEditForm = (form) => {
        setSelectedForm(form);
        setCreateForm(false);
    };

    const handleDuplicate = () => {
        setRefreshList((prev) => !prev);
    };

    const handleNewForm = (isNew) => {
        setSelectedForm(null);
        setCreateForm(isNew);
    };

    const handleSaveForm = () => {
        setSelectedForm(null);
        setRefreshList((prev) => !prev);
        setCreateForm(null);
        setFeedbackMessage("Form saved successfully!");
    };

    const handleCancelEdit = () => {
        setSelectedForm(null);
    };

    return (
        <div className="dashboard">
            <Sidebar/>

            <main className="main-content">
                <header className="header component">
                    <span className="component-header">Forms</span>
                    <button className="btn btn-primary action btn-new-form" onClick={() => handleNewForm(true)}>
                        <i className="fa fa-plus"></i> New Form
                    </button>
                </header>
                <p><a href="/dashboard"> Home </a> &gt; Forms  </p>
                <hr />

                {/* 🔹 Show Loading Indicator */}
                {loading ? (
                    <div className="loading-container">
                        <p>Loading forms...</p>
                    </div>
                ) : (
                    <>
                        {/* Conditional Rendering */}
                        {selectedForm ? (
                            <CreateFormPage
                                initialFormData={selectedForm}
                                onSave={handleSaveForm}
                                onCancel={handleCancelEdit}
                            />
                        ) : null}
                        {createForm ? (
                            <CreateFormPage
                                initialFormData={selectedForm}
                                onSave={handleSaveForm}
                                onCancel={handleCancelEdit}
                            />
                        ) : null}
                        {!selectedForm && !createForm ? (
                            <FormList forms={forms} onEdit={handleEditForm} onDuplicate={handleDuplicate} />
                        ) : null}
                    </>
                )}

                {/* Feedback Modal */}
                {feedbackMessage && (
                    <FeedbackModal
                        message={feedbackMessage}
                        onClose={() => setFeedbackMessage(null)}
                    />
                )}
            </main>
        </div>
    );
};

export default FormManagement;